import FormBlock from "../../FormBlock";
import { useAppContext } from "../../../../_context";
import CourtRow from "./CourtRow";
import { useReducer } from "react";
import { Add } from "@material-ui/icons";
import { availableSportNames } from "../../../../utilities/Constants";

let index = 0;

const defaultCourt = {
  sport: "",
  numberOfCourts: 0,
  location: "",
  surface: [],
  lights: "",
  index,
};

const getNewCourt = () => {
  return { ...defaultCourt };
};

const reducer = (state, action) => {
  let courts;

  switch (action.type) {
    case "add-court": {
      const newCourt = getNewCourt();
      index++;
      newCourt.index = index;
      courts = state.courts;
      courts.push(newCourt);
      return { ...state, courts };
    }

    case "remove-court": {
      courts = state.courts.filter((item) => item.index !== action.index);
      return { ...state, courts };
    }

    case "set-item": {
      courts = state.courts.map((item) => {
        if (item.index === action.item.index) {
          if (action.item.surfaceOther) {
            action.item.surface.push(action.item.surfaceOther);
          }
          return action.item;
        }

        return item;
      });

      return { ...state, courts };
    }

    default: {
      throw new Error(
        `Unknown event ${action.type}. Received: ${JSON.stringify(
          action || {},
        )}`,
      );
    }
  }
};

const defaultState = { courts: [getNewCourt()] };

const CourtSection = ({ errors }) => {
  const [{ tx }] = useAppContext();
  const [state, dispatch] = useReducer(reducer, defaultState);
  const usedSports = state.courts.map((item) => item.sport);
  const nAvailableSports = availableSportNames.length;

  return (
    <div>
      {state.courts.map((court) => {
        return (
          <CourtRow
            key={court.index}
            court={court}
            hasClose={state.courts.length > 1}
            errors={errors}
            usedSports={usedSports}
            dispatcher={dispatch}
          />
        );
      })}

      <input
        type="hidden"
        value={JSON.stringify(
          state.courts.map((item) => {
            const newItem = {
              ...item,
              indoor: item.location === "indoor" || item.location === "both",
              outdoor: item.location === "outdoor" || item.location === "both",
              lights: item.lights === "yes",
            };
            delete newItem.location;
            return newItem;
          }),
        )}
        id="signup-courts"
      />

      {usedSports.length < nAvailableSports ? (
        <FormBlock label="" className="py-4">
          <div className="text-center">
            <span
              onClick={() => dispatch({ type: "add-court" })}
              className="text-primary cursor-pointer fw-bold">
              <span className="mr-2">
                <Add />
              </span>
              <span className="align-middle">{tx["Add new court"]}</span>
            </span>
            <p className="mb-0 font-size-12">
              {
                tx[
                  "If the club has multiple racket sports, please add them here."
                ]
              }
            </p>
          </div>
        </FormBlock>
      ) : null}
    </div>
  );
};

export default CourtSection;
